import Layout from '@/views/layout/index.vue'
const rootDir: string = './views'
const systemDir: string = `${rootDir}/systemManage`
const heritageUnitDir: string = `${rootDir}/heritageUnit`
const otherUnitDir: string = `${rootDir}/otherUnit`
const eighthHeritageDir: string = `${rootDir}/eighthHeritage`
const heritageCruiseDir: string = `${rootDir}/heritageCruise`
export const routerMap = [
  { name: '视频播放', path: '/videoPlayWin', component: () => import(`${rootDir}/openWin/index.vue`), hidden: true },
  { name: '登陆', path: '/login', component: () => import(`${rootDir}/login/index.vue`), hidden: true },
  { name: '出错啦~~', path: '/404', component: () => import(`${rootDir}/404.vue`), hidden: true },
  { name: '浏览器不支持', path: '/browsers', component: () => import(`${rootDir}/browsers.vue`), hidden: true },
  {
    path: '/', component: Layout, hidden: true,
    children: [{ path: '', component: () => import(`${rootDir}/dashboard/index.vue`) }]
  },
  {
    path: '/dashboard', component: Layout, hidden: true,
    children: [{ path: '', component: () => import(`${rootDir}/dashboard/index.vue`) }]
  },
  {
    path: '/myprofile', component: Layout, hidden: true,
    children: [
      // { path: '', component: () => import(`${systemDir}/user/view.vue`) }
      { path: '', component: () => import(`${systemDir}/user/view.vue`) }
    ]
  },
  //#region 系统设置
  {
    //健康码设置
    path: '/HealthRule', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/healthRule/form.vue`) }
    ]
  },
  {
    path: '/ApiLogs', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/apiLogs/list.vue`) },
    ]
  },
  {
    path: '/User', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/user/list.vue`) },
      { path: 'New', component: () => import(`${systemDir}/user/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${systemDir}/user/form.vue`) },
      //员工转岗
      { path: 'Transfer/:id', component: () => import(`${systemDir}/user/form.vue`) },
      { path: 'View/:id', component: () => import(`${systemDir}/user/view.vue`) }
    ]
  },
  {
    //多语言配置
    path: '/Language', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/langue/list.vue`) },
      { path: 'New', component: () => import(`${systemDir}/langue/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${systemDir}/langue/form.vue`) },
      { path: 'View/:id', component: () => import(`${systemDir}/langue/form.vue`) }
    ]
  },
  {
    //分色卡配置表
    path: '/ScoreColors', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/scoreColors/form.vue`) }
    ]
  },
  {
    path: '/Lookup', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/lookup/list.vue`) },
      { path: 'New', component: () => import(`${systemDir}/lookup/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${systemDir}/lookup/form.vue`) },
      { path: 'View/:id', component: () => import(`${systemDir}/lookup/form.vue`) }
    ]
  },
  {
    path: '/LookupChild', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/lookup/child/list.vue`) },
    ]
  },
  {
    path: '/CruiseBaseItem', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/cruiseBaseItem/list.vue`) },
    ]
  },
  {
    path: '/AttachSetting', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/attachSetting/list.vue`) },
      { path: 'New', component: () => import(`${systemDir}/attachSetting/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${systemDir}/attachSetting/form.vue`) },
      { path: 'View/:id', component: () => import(`${systemDir}/attachSetting/form.vue`) }
    ]
  },
  {
    path: '/Menu', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/menu/list.vue`) },
      { path: 'New', component: () => import(`${systemDir}/menu/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${systemDir}/menu/form.vue`) },
      { path: 'View/:id', component: () => import(`${systemDir}/menu/form.vue`), }
    ]
  },
  {
    path: '/Role', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/role/list.vue`) },
      { path: 'New', component: () => import(`${systemDir}/role/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${systemDir}/role/form.vue`) },
      { path: 'View/:id', component: () => import(`${systemDir}/role/form.vue`) }
    ]
  },
  {
    path: '/Announcements', component: Layout,
    children: [
      { path: '', component: () => import(`${systemDir}/notification/list.vue`) },
      { path: 'Edit/:id', component: () => import(`${systemDir}/notification/form.vue`) },
      { path: 'New', component: () => import(`${systemDir}/notification/form.vue`) }
    ]
  },
  //#endregion
  {
    path: '/GovDoc', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/govDoc/list.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/govDoc/form.vue`) },
      { path: 'New', component: () => import(`${rootDir}/govDoc/form.vue`) }
    ]
  },
  {
    path: '/LawFile', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/lawFile/list.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/lawFile/form.vue`) },
      { path: 'New', component: () => import(`${rootDir}/lawFile/form.vue`) }
    ]
  },
  {
    path: '/CruiseTeam', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/cruiseTeam/list.vue`) }
    ]
  },
  {
    path: '/UnitGis', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/unitGis/map.vue`) }
    ]
  },
  {
    path: '/HeritageUnit', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageUnitDir}/list.vue`) },
      { path: 'New', component: () => import(`${heritageUnitDir}/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${heritageUnitDir}/form.vue`) }
    ]
  },
  {
    path: '/OtherUnit', component: Layout,
    children: [
      { path: '', component: () => import(`${otherUnitDir}/list.vue`) },
      { path: 'New', component: () => import(`${otherUnitDir}/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${otherUnitDir}/form.vue`) }
    ]
  },
  {
    path: '/UnitRspblty', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/unitRspblty/list.vue`) },
      { path: 'New', component: () => import(`${rootDir}/unitRspblty/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/unitRspblty/form.vue`) }
    ]
  },
  {
    path: '/UnitDevice', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/unitDevice/list.vue`) },
      { path: 'New', component: () => import(`${rootDir}/unitDevice/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/unitDevice/form.vue`) }
    ]
  },
  {
    path: '/Supervise', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/supervise/list.vue`) },
      { path: 'New', component: () => import(`${rootDir}/supervise/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/supervise/form.vue`) }
    ]
  },
  {
    path: '/DeviceData', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/deviceData/list.vue`) }
    ]
  },
  {
    path: '/DeviceDataChart', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/deviceData/chartList.vue`) }
    ]
  },
  {
    path: '/VideoList', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/videoDevice/list.vue`) },
      { path: 'Discover', component: () => import(`${rootDir}/videoDevice/discover.vue`) },
      { path: 'New', component: () => import(`${rootDir}/videoDevice/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/videoDevice/form.vue`) }
    ]
  },
  {
    path: '/VideoLogs', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/videoDevice/logList.vue`) },
    ]
  },
  {
    path: '/VideoPlay', component: Layout,
    children: [
      //原路径为 'videoDevice/play.vue' 改版为 'videoDevice/play/index.vue'
      { path: '', component: () => import(`${rootDir}/videoDevice/play/index.vue`), meta: { title: 'VideoPlay' } }
    ]
  },
  {
    path: '/VideoPlayBack', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/videoDevice/playBack.vue`), meta: { title: 'PlayBack' } }
    ]
  },
  {
    //运行状态检测
    path: '/VideoStatusRuntime', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/videoDevice/runtime/list.vue`) }
    ]
  },
  {
    //事件联动
    path: '/HikEvent', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/hikEvent/list.vue`) },
      { path: 'New', component: () => import(`${rootDir}/hikEvent/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/hikEvent/form.vue`) },
      { path: 'View/:id', component: () => import(`${rootDir}/hikEvent/form.vue`) }
    ]
  },
  {
    path: '/UnitBuiltFireSafety', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/unitBuiltFireSafety/list.vue`) },
      { path: 'New', component: () => import(`${rootDir}/unitBuiltFireSafety/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/unitBuiltFireSafety/form.vue`) }
    ]
  },
  //#region 第八批文保单位申报
  {
    //八批国保申报
    path: '/CountryUnitApply', component: Layout,
    children: [
      { path: '', component: () => import(`${eighthHeritageDir}/list.vue`) },
      { path: 'New', component: () => import(`${eighthHeritageDir}/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${eighthHeritageDir}/form.vue`) },
    ]
  },
  {
    //八批国保成果展示
    path: '/CountryUnitResult', component: Layout,
    children: [
      { path: '', component: () => import(`${eighthHeritageDir}/list.vue`) }
    ]
  },
  {
    //八批省保申报
    path: '/ProvinceUnitApply', component: Layout,
    children: [
      { path: '', component: () => import(`${eighthHeritageDir}/list.vue`) },
      { path: 'New', component: () => import(`${eighthHeritageDir}/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${eighthHeritageDir}/form.vue`) }
    ]
  },
  {
    //八批省保成果展示
    path: '/ProvinceUnitResult', component: Layout,
    children: [
      { path: '', component: () => import(`${eighthHeritageDir}/list.vue`) }
    ]
  },
  {
    path: '/EighthUnitEntrust', component: Layout,
    children: [
      { path: '', component: () => import(`${eighthHeritageDir}/entrustList.vue`) },
      { path: 'Edit/:id', component: () => import(`${eighthHeritageDir}/form.vue`) }
    ]
  },
  {
    path: '/ExpertAssessment', component: Layout,
    children: [
      { path: '', component: () => import(`${eighthHeritageDir}/expertAssessment/list.vue`) },
      { path: 'Review/:id/:allocateId', component: () => import(`${eighthHeritageDir}/expertAssessment/review.vue`) }
    ]
  },
  //#endregion
  //#region 文物安全
  {
    path: '/CruisePlan', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageCruiseDir}/cruisePlan/list.vue`) },
      { path: 'New', component: () => import(`${heritageCruiseDir}/cruisePlan/form.vue`) },
      { path: 'Copy/:id', component: () => import(`${heritageCruiseDir}/cruisePlan/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${heritageCruiseDir}/cruisePlan/form.vue`) },
      { path: 'View/:id', component: () => import(`${heritageCruiseDir}/cruisePlan/form.vue`) }
    ]
  },
  {
    path: '/CruiseList', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageCruiseDir}/cruiseList/list.vue`) },
      { path: 'New', component: () => import(`${heritageCruiseDir}/cruiseList/form.vue`) },
      { path: 'NewMakeup', component: () => import(`${heritageCruiseDir}/cruiseMakeup/form.vue`) },
      { path: 'EditMakeup/:id', component: () => import(`${heritageCruiseDir}/cruiseMakeup/form.vue`) }
    ]
  },
  {
    path: '/CruiseEvent', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageCruiseDir}/cruiseEvent/list.vue`) },
      { path: 'Edit/:id', component: () => import(`${heritageCruiseDir}/cruiseEvent/form.vue`) },
      { path: 'View/:id', component: () => import(`${heritageCruiseDir}/cruiseEvent/view.vue`) }
    ]
  },
  {
    path: '/CruiseTrack', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageCruiseDir}/cruiseTrack/list.vue`) },
      { path: 'View/:id', component: () => import(`${heritageCruiseDir}/cruiseTrack/view.vue`) }
    ]
  },
  {
    path: '/CruiseLogs', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageCruiseDir}/cruiseLog/list.vue`) },
      // { path: 'View/:id', component: () => import(`${heritageCruiseDir}/cruiseLog/view.vue`) }
    ]
  },
  {
    path: '/CruiseMakeup', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageCruiseDir}/cruiseMakeup/list.vue`) },
      { path: 'New', component: () => import(`${heritageCruiseDir}/cruiseMakeup/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${heritageCruiseDir}/cruiseMakeup/form.vue`) },
      { path: 'View/:id', component: () => import(`${heritageCruiseDir}/cruiseMakeup/view.vue`) }
    ]
  },
  {
    path: '/UnitSnapshot', component: Layout,
    children: [
      { path: '', component: () => import(`${heritageCruiseDir}/unitSnapshot/list.vue`) }
    ]
  },
  //#endregion
  //#region 统计分析
  {//巡查情况统计
    path: '/AnalyzeCruiseLogs', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/analyze/cruiseLogs.vue`) },
    ]
  },
  {//日常巡查
    path: '/AnalyzeCruise', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/analyze/cruise.vue`) },
    ]
  },
  {//问题上报
    path: '/AnalyzeEvent', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/analyze/issue.vue`) },
    ]
  },
  {//文保单位
    path: '/AnalyzeUnit', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/analyze/unit.vue`) },
    ]
  },
  {//文保单位风险评估统计
    path: '/UnitRisk', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/analyze/unitRisk.vue`) }
    ]
  },
  //#endregion
  //#region 文件管理
  {
    path: '/Documents', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/documents/list.vue`) },
      { path: 'New', component: () => import(`${rootDir}/documents/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/documents/form.vue`) }
    ]
  },
  //#endregion
  //#region 案件管理
  {
    path: '/UnitCase', component: Layout,
    children: [
      { path: '', component: () => import(`${rootDir}/unitCase/list.vue`) },
      { path: 'New', component: () => import(`${rootDir}/unitCase/form.vue`) },
      { path: 'Edit/:id', component: () => import(`${rootDir}/unitCase/form.vue`) }
    ]
  },
  //#endregion
  { path: '*', redirect: '/404', hidden: true }
]
